<template>
  <b-form>
    <b-row v-if="order && statusDescription">
      <span class="font-weight-bold px-3 mt-3">{{ description }}</span>
    </b-row>
    <b-row>
      <b-col lg="auto" v-if="invoiceData">
        <h6 class="font-weight-bold pt-3">Dane do faktury:</h6>
        <p class="mb-1"><b>NIP: </b> {{ invoiceData.nip }}</p>
        <p class="mb-1">
          <b>Nazwa: </b> {{ invoiceData.n1 }} {{ invoiceData.n2 }}
        </p>
        <p class="mb-1"><b>Adres: </b> {{ invoiceData.address }}</p>
        <p class="mb-1"><b>Kod pocztowy: </b> {{ invoiceData.post_code }}</p>
        <p class="mb-1"><b>Miasto: </b> {{ invoiceData.city }}</p>
      </b-col>
      <b-col lg="auto" v-if="order.AKL">
        <h6 class="font-weight-bold pt-3">Dane do wysyłki:</h6>
        <p class="mb-1"><b>Nazwa: </b> {{ order.AKN }}</p>
        <p class="mb-1"><b>Adres: </b> {{ order.AKA }}</p>
        <p class="mb-1"><b>Kod i poczta: </b> {{ order.AKM }}</p>
      </b-col>
    </b-row>
    <b-row>
      <h5 class="font-weight-bold px-3 pt-3">Zamówione produkty</h5>
    </b-row>
    <b-table :small="true" :items="products" :fields="fields" foot-clone>
      <template #cell(name)="data">
        <span v-html="productName(data.item)"></span>
      </template>

      <template #cell(netto)="data">
        {{ commaFormat(data.item.netto) }} zł
      </template>

      <template #cell(vat)="data"> {{ data.item.vat }} % </template>

      <template #cell(brutto)="data">
        {{ commaFormat(data.item.brutto) }} zł
      </template>

      <template #foot(name)>
        <span v-if="discountRecommendation" class="text-danger"
          >Udzielony RABAT za polecenie {{ program.toUpperCase()
          }}<sup>®</sup>:</span
        ><br v-if="discountRecommendation" />
        <p class="mb-0 mt-2">Forma płatności: {{ paymentType }}</p>
        <div v-if="ossPromotion">
          <span class="text-danger"> Udzielony rabat VAT OSS za 0zł </span>
          <br />
        </div>
        <div v-if="courseDiscount">
          <span class="text-danger">
            Udzielono RABATU na zakup Certyfikowanego Kursu Obsługi SKP<sup
              >®</sup
            >
            za 79zł
          </span>
          <br />
        </div>
      </template>

      <template #foot(ilosc)>
        <br v-if="discountRecommendation" />
        <p v-if="order.ZAPLACONO_ILE != null" class="mb-0 mt-2">Zapłacono:</p>
        <p class="mb-0 mt-2" v-else>Do zapłaty:</p>
      </template>

      <template #foot(netto)>
        <span v-if="discountRecommendation" class="text-danger"
          >-{{ commaFormat(discountRecommendation.amount) }} zł</span
        ><br v-if="discountRecommendation" />
        <p class="mb-0 mt-2">{{ commaFormat(order.NETTO) }} zł</p>
      </template>

      <template #foot(vat)>
        <br v-if="discountRecommendation" />
        <p class="mb-0 mt-2">{{ order.VAT }} %</p>
      </template>

      <template #foot(brutto)>
        <br v-if="discountRecommendation" />
        <p class="mb-0 mt-2">{{ commaFormat(order.BRUTTO) }} zł</p>
      </template>
    </b-table>
    <p v-if="proformaInvoice" class="mt-2 ml-1">
      <a :href="proformaInvoice"
        >Pobierz Fakturę Pro forma <i class="fas fa-file-invoice py-0"></i
      ></a>
    </p>
    <p v-if="invoice" class="mt-2 ml-1">
      <a :href="invoice"
        >Pobierz Fakturę VAT <i class="fas fa-file-invoice py-0"></i
      ></a>
    </p>
  </b-form>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: 'OrderDetails',
  props: {
    order: {},
    products: {},
    paymentType: {},
    invoiceData: {},
    invoice: {},
    proformaInvoice: {},
    discountRecommendation: {},
    statusDescription: {},
  },
  data() {
    return {
      fields: [
        { key: 'name', label: 'Nazwa' },
        { key: 'ilosc', label: 'Ilość' },
        { key: 'netto', label: 'Cena netto' },
        { key: 'vat', label: 'VAT' },
        { key: 'brutto', label: 'Cena brutto' },
      ],
      addressOptions: [
        { text: 'Taki sam jak wyżej', value: 0, disabled: true },
        { text: 'INNY - podany poniżej', value: 1, disabled: true },
      ],
      year: process.env.MIX_AKTU_YEAR,
    };
  },
  computed: {
    ...mapGetters({
      program: 'getProgram',
    }),
    ossPromotion() {
      return this.order.promotion === 604 && this.order.L === 1;
    },
    courseDiscount() {
      return this.order.promotion === 610;
    },
    description() {
      return this.order.PL.includes('POBRANIE') &&
        this.order.resolved !== 1 &&
        this.order.deleted_at === null
        ? 'Zamówienie złożone. Zamówienie wyślemy w ciągu 7 dni. Opłać je przy odbiorze. W przesyłce znajdziesz najnowszą wersję programu oraz fakturę VAT.'
        : this.statusDescription;
    },
  },
  methods: {
    commaFormat(value) {
      return Number(value).toLocaleString('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    productName(product) {
      if (product.id_ceny === 99) {
        if (this.program == 'sam') {
          return (
            'Bezpłatne przejście na SKP® z Opieką Serwisową' +
            moment(this.order.DATA).year()
          );
        } else {
          return 'Opieka Serwisowa ' + moment(this.order.DATA).year();
        }
      }

      if (product.id_ceny === 1) {
        return 'Program SKP<sup>®</sup> dla Firm';
      }
      if (product.id_ceny === 2) {
        return 'Program SKP<sup>®</sup> dla Biur';
      }
      if (product.id_ceny === 1) {
        return 'Program SKP<sup>®</sup> wielostanowiskowa dla Biur';
      }

      return product.name !== null &&
        product.name !== '' &&
        product.name !== undefined
        ? product.name
        : product.product_data.OPIS;
    },
  },
};
</script>

<style scoped></style>
